<div class="main-container">
  <div class="map padding-bottom-30">
    <google-map
      height="300px"
      width="100%"
      [center]="center"
      [zoom]="zoom"
      [options]="mapOptions"
      (mapClick)="mapClicked($event)">

      <map-marker
        *ngFor="let m of markers; let i = index"
        #marker="mapMarker"
        [position]="m.position"
        [label]="m.label"
        [options]="{ draggable: m.draggable }"
        (mapClick)="clickedMarker(m.label, i, marker)"
        (mapDragend)="markerDragEnd(m, $event)">
      </map-marker>

      <map-info-window>
        <strong>{{ selectedMarkerLabel }}</strong>
      </map-info-window>

      <map-circle
        [center]="center"
        [radius]="circleOptions.radius"
        [options]="circleOptions">
      </map-circle>
    </google-map>
  </div>
  <div class="main-contents">
    <div class="container">
      <h2 class="padding-bottom-15 text-center {{emaiSend}}">How can I help you?</h2>
      <div class="row">
        <div class="col-md-6 contact-form padding-bottom-30">
          <div class="alert alert-success" role="alert" *ngIf="emaiSend">
            Thank you for your message!
          </div>
          <app-slider *ngIf="emaiSend"></app-slider>
          <form [formGroup]="contactForm" novalidate action="" class="form"  *ngIf="!emaiSend">
              <div class="form-group">
                  <label>Your Name:</label>
                  <input type="text" formControlName="yourName" name="yourName" class="form-control">
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('yourName').hasError('required') && contactForm.get('yourName').touched">
                  Please enter your name.
              </div>
              <div class="form-group">
                  <label>Email:</label>
                  <input type="text" formControlName="email" name="email" class="form-control">
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('email').hasError('required') && contactForm.get('email').touched">
                  Please enter email.
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('email').hasError('maxlength') && contactForm.get('email').touched">
                  Maximum 30 characters are allowed.
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('email').hasError('pattern') && contactForm.get('email').touched">
                Please enter the correct email format.
              </div>
              <div class="form-group">
                  <label>Message:</label>
                  <textarea type="text" formControlName="message" name="message" class="form-control" height="250"></textarea>
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('message').hasError('required') && contactForm.get('message').touched">
                  Please enter your message.
              </div>
              <div class="alert alert-danger" *ngIf="contactForm.get('message').hasError('maxlength') && contactForm.get('message').touched">
                  Maximum 255 characters are allowed.
              </div>
              <button class="btn btn-success right" [disabled]="contactForm.invalid" (click)="onSubmit()">Send</button>
          </form>
        </div>
        <div class="col-md-6 social-media padding-bottom-30">
          <h5 class="title">Follow Bill:</h5>
          <instagram-post></instagram-post>
          <tumblr-posts></tumblr-posts>
          <!-- <facebook-photos></facebook-photos> -->
        </div>
      </div>
    </div>
  </div>
</div>